module.exports = __webpack_public_path__ + "static/media/icon-truck-checked.632c67a6.svg";